<!-- Close Button -->
<button class="close-icon" tabindex="-1" type="button" mat-icon-button (click)="onClickCloseDialog()">
  <mat-icon>close</mat-icon>
</button>

<!-- Title -->
<h5 cdkFocusInitial tabindex="-1" mat-dialog-title>{{ "duplicate_campata_dialog.duplicate_campata" | translate }}</h5>

<!-- Content -->
<mat-dialog-content>
  <!-- Form -->
  <form class="dialog-form" [formGroup]="campataForm" (ngSubmit)="onSubmitForm()">
    <!-- Selected Campata -->
    <mat-form-field>
      <mat-label>{{
        "duplicate_campata_dialog.selected_campata" | translate
        }}</mat-label>
      <mat-select formControlName="selectedCampataNo">
        <mat-option [value]="existingCampata[bridgeConstants.partNo]"
          *ngFor="let existingCampata of existingCampateList">
          {{ existingCampata[bridgeConstants.partNo] }}
        </mat-option>
      </mat-select>
      <mat-error>
        <cube-validation-error field="Selected Campata"
          [control]="campataForm.get(['selectedCampataNo'])"></cube-validation-error>
      </mat-error>
    </mat-form-field>

    <!-- New Campata No. -->
    <mat-form-field>
      <mat-label>{{
        "duplicate_campata_dialog.new_campata_no" | translate
        }}</mat-label>
      <mat-select formControlName="newCampataNo">
        <mat-option [value]="availableCampataNo.value" *ngFor="let availableCampataNo of availableCampataNoList">
          {{ availableCampataNo.value }}
        </mat-option>
      </mat-select>
      <mat-error>
        <cube-validation-error field="New Campata No."
          [control]="campataForm.get(['newCampataNo'])"></cube-validation-error>
      </mat-error>
    </mat-form-field>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <!-- Cancel -->
      <button type="button" mat-flat-button color="warn" (click)="onClickCloseDialog()">
        {{ "common.buttons.cancel" | translate }}
        <mat-icon>remove_circle_outline</mat-icon>
      </button>

      <!-- Duplicate -->
      <button type="submit" mat-raised-button color="primary" [disabled]="campataForm.invalid">
        {{ "duplicate_campata_dialog.duplicate" | translate }}
      </button>
    </div>
  </form>
</mat-dialog-content>
